// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { AlarmsHistory_abstract } from './../abstract/SagaSchema/AlarmsHistory_abstract';
export class AlarmsHistory extends AlarmsHistory_abstract {}
